(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-timeline"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bt-bt:not([data-bt-bt-init])').forEach(function (section) {
    section.setAttribute('data-bt-bt-init', '');
    var items = section.querySelectorAll('[data-bt-bt-item]');
    if (!items.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      var trigger = vh * 0.42;
      var activeIdx = -1;
      var bestDist = Infinity;
      for (var i = 0; i < items.length; i++) {
        var rect = items[i].getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        if (rect.bottom > 0 && rect.top < vh) {
          var dist = Math.abs(center - trigger);
          if (dist < bestDist) { bestDist = dist; activeIdx = i; }
        }
      }
      if (activeIdx === -1) {
        var lastRect = items[items.length - 1].getBoundingClientRect();
        if (lastRect.bottom < 0) activeIdx = items.length - 1;
      }
      for (var j = 0; j < items.length; j++) {
        if (activeIdx >= 0 && j <= activeIdx) {
          items[j].classList.add('bt-bt__item--active');
          items[j].classList.remove('bt-bt__item--faded');
        } else {
          items[j].classList.remove('bt-bt__item--active');
          items[j].classList.add('bt-bt__item--faded');
        }
      }
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-blog-page"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bt-bp').forEach(function(sec){
  var chips = sec.querySelectorAll('[data-bt-bp-filters] [data-tag]');
  var cards = sec.querySelectorAll('[data-bt-bp-card]');
  if (!chips.length || !cards.length) return;
  chips.forEach(function(chip){
    chip.addEventListener('click', function(){
      var tag = chip.dataset.tag || '';
      chips.forEach(function(c){ c.classList.toggle('is-active', c === chip); });
      cards.forEach(function(card){
        var tags = (card.dataset.tags || '').split(',').filter(Boolean);
        var match = !tag || tags.indexOf(tag) > -1;
        card.style.display = match ? '' : 'none';
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-bt-faq-single]').forEach(function(list){
  list.addEventListener('toggle', function(e){
    if (e.target.tagName !== 'DETAILS' || !e.target.open) return;
    list.querySelectorAll('details[open]').forEach(function(d){ if (d !== e.target) d.open = false; });
  }, true);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-press-logos"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bt-pl:not([data-bt-pl-init])').forEach(function (sec) {
    sec.setAttribute('data-bt-pl-init', '');
    var row = sec.querySelector('[data-bt-pl-row]');
    if (!row) return;
    var items = row.querySelectorAll('[data-bt-pl-item]');
    if (items.length < 2) {
      if (items[0]) items[0].classList.add('is-active');
      return;
    }
    var interval = parseInt(row.dataset.btPlInterval, 10) || 4000;
    var idx = 0;
    var mq = window.matchMedia('(max-width: 749px)');
    function setActive(i) {
      if (i == null || i < 0 || i >= items.length || isNaN(i)) i = 0;
      idx = i;
      items.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
    }
    function tick() {
      if (!mq.matches) return;
      setActive((idx + 1) % items.length);
    }
    setActive(0);
    var timer = setInterval(tick, interval);
    function onResize() {
      if (mq.matches) {
        setActive(idx);
      } else {
        items.forEach(function (el) { el.classList.remove('is-active'); });
      }
    }
    (mq.addEventListener ? mq.addEventListener('change', onResize) : mq.addListener(onResize));
    // Endless loop guarantees:
    // 1. Page restored from bfcache → re-sync active item
    window.addEventListener('pageshow', function () {
      if (mq.matches) setActive(idx);
    });
    // 2. Tab refocused after being hidden → re-sync (setInterval is throttled in background)
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && mq.matches) setActive(idx);
    });
    // 3. Watchdog — every 2 intervals, if no item is active on mobile, force-fix
    setInterval(function () {
      if (!mq.matches) return;
      var anyActive = false;
      items.forEach(function (el) { if (el.classList.contains('is-active')) anyActive = true; });
      if (!anyActive) setActive(0);
    }, interval * 2);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  var toggle = document.querySelector('[data-bt-menu-toggle]');
  var drawer = document.querySelector('[data-bt-drawer]');
  if (toggle && drawer && !toggle.hasAttribute('data-bt-init')) {
    toggle.setAttribute('data-bt-init', '');
    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('bt-header-drawer-open', open);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ih-video-carousel"] && !Shopify.designMode) return;
  try {
    
function ivcInitAll(){
document.querySelectorAll('.ivc:not([data-ivc-init])').forEach(function(sec){
  sec.setAttribute('data-ivc-init','');
  var cards = sec.querySelectorAll('[data-ivc-card]');
  if (!cards.length) return;
  function loadSources(card){
    if (card.dataset.ivcLoaded === 'true') return;
    var v = card.querySelector('[data-ivc-video]');
    if (!v) return;
    v.querySelectorAll('source[data-src]').forEach(function(s){ s.src = s.dataset.src; s.removeAttribute('data-src'); });
    v.load();
    card.dataset.ivcLoaded = 'true';
  }
  function tryAutoplay(card, v){
    loadSources(card);
    v.muted = true; // belt-and-braces: some webviews ignore the HTML attribute after load()
    v.play().then(function(){ card.dataset.paused = 'false'; })
            .catch(function(){ card.dataset.paused = 'true'; }); // blocked autoplay → show ▶ so a tap can start it
  }
  function muteAllExcept(card){
    cards.forEach(function(c){
      if (c === card) return;
      var v = c.querySelector('[data-ivc-video]');
      if (v) v.muted = true;
      c.dataset.muted = 'true';
    });
  }
  cards.forEach(function(card){
    var v = card.querySelector('[data-ivc-video]');
    if (!v) return;
    card.addEventListener('click', function(e){
      if (e.target.closest('[data-ivc-sound]')) return;
      if (v.paused) {
        loadSources(card);
        delete card.dataset.userPaused;
        v.play().then(function(){ card.dataset.paused = 'false'; })
                .catch(function(){ card.dataset.paused = 'true'; });
      } else {
        v.pause();
        card.dataset.paused = 'true';
        card.dataset.userPaused = 'true';
      }
    });
    var soundBtn = card.querySelector('[data-ivc-sound]');
    if (soundBtn) {
      soundBtn.addEventListener('click', function(e){
        e.stopPropagation();
        loadSources(card);
        v.muted = !v.muted;
        card.dataset.muted = v.muted ? 'true' : 'false';
        soundBtn.textContent = v.muted ? '🔇' : '🔊';
        if (!v.muted) muteAllExcept(card);
        if (v.paused) v.play().catch(function(){ card.dataset.paused = 'true'; });
      });
    }
    v.addEventListener('pause', function(){ card.dataset.paused = 'true'; });
    v.addEventListener('play',  function(){ card.dataset.paused = 'false'; });
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var card = entry.target;
        var v = card.querySelector('[data-ivc-video]');
        if (!v) return;
        if (entry.isIntersecting) {
          if (card.dataset.userPaused !== 'true') tryAutoplay(card, v);
        } else {
          if (!v.paused) v.pause();
        }
      });
    }, { rootMargin: '150px' });
    cards.forEach(function(card){ io.observe(card); });
  } else {
    cards.forEach(function(card){
      var v = card.querySelector('[data-ivc-video]');
      if (v) tryAutoplay(card, v);
    });
  }
});
}
ivcInitAll();
document.addEventListener('shopify:section:load', ivcInitAll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-bottom-cta"] && !Shopify.designMode) return;
  try {
    
  // Defer init until browser is idle — bar isn't above-fold, doesn't compete with LCP render
  var btSbInit = function () {
    document.querySelectorAll('.bt-sb:not([data-bt-sb-init])').forEach(function (bar) {
      bar.setAttribute('data-bt-sb-init', '');
      var mode = bar.dataset.mode || 'after-trigger';
      var triggerSel = bar.dataset.trigger || '';
      var hideSel = bar.dataset.hide || '';
      var afterPx = parseInt(bar.dataset.afterPx, 10) || 0;
      var triggerEl = triggerSel ? document.querySelector(triggerSel) : null;
      var hideEl = hideSel ? document.querySelector(hideSel) : null;
      var ticking = false;
      function compute() {
        var shouldShow = true;
        if (mode === 'always') {
          shouldShow = true;
        } else if (mode === 'scroll-distance') {
          shouldShow = window.scrollY > afterPx;
        } else if (mode === 'after-trigger') {
          if (triggerEl) {
            var r = triggerEl.getBoundingClientRect();
            shouldShow = r.bottom < 0;
          } else {
            shouldShow = window.scrollY > 200;
          }
        }
        if (shouldShow && hideEl) {
          var hr = hideEl.getBoundingClientRect();
          if (hr.top < window.innerHeight) shouldShow = false;
        }
        bar.classList.toggle('is-visible', shouldShow);
        bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        ticking = false;
      }
      function onScroll() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(compute); }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      compute();
      setTimeout(compute, 100);
    });
  };
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(btSbInit, { timeout: 2000 });
  } else {
    setTimeout(btSbInit, 200);
  }

  } catch(e) { console.error(e); }
})();
})();
